import { useQuery, gql } from "@apollo/client";

export interface PostShape {
  id: string;
  title: string;
  authorName: string;
  createdAt: string;
  excerpt: string;
  role: string;
  content: {
    html: string;
  };
}

const QUERY = gql`
  query QueryPosts($search: String!) {
    posts(
      first: 1000
      orderBy: createdAt_DESC
      where: {
        OR: [
          { title_contains: $search }
          { authorName_contains: $search }
          { excerpt_contains: $search }
        ]
      }
    ) {
      id
      title
      id
      title
      authorName
      createdAt
      role
      excerpt
      content {
        html
      }
    }
  }
`;

interface Props {
  search: string;
}

const usePosts = ({ search }: Props) =>
  useQuery<{
    posts: Array<PostShape>;
  }>(QUERY, {
    variables: {
      search,
    },
  });

export default usePosts;
